import React, { Fragment, useEffect, useState } from 'react';
import { createGlobalStyle } from 'styled-components';
import { func, object, string } from 'prop-types';
import { GoogleMapsAutocomplete } from 'library/components/google-maps-api';

const StyledAutocompleteResults = createGlobalStyle`
  .pac-container {
    z-index: 10000000;
  }
`;

const GooglePlacesInput = ({
  ariaLabel,
  label,
  handleUpdatePlaceSelection,
  userCoordinates,
  onUnmount,
}) => {
  const [placeSelection, setPlaceSelection] = useState(null);

  useEffect(() => {
    if (userCoordinates) {
      setPlaceSelection(userCoordinates);
    } else {
      setPlaceSelection(false);
    }
  }, [userCoordinates]);

  // cleanup on unmount
  useEffect(() => {
    return () => {
      onUnmount();
    };
  }, []);

  const handleAutocompleteSelection = (event) => {
    let location = event?._data?.value;
    if (!(location?.name && location?.lat && location?.lng)) {
      location = false;
    }

    const sameLocation =
      location === placeSelection ||
      (location?.name === placeSelection?.name &&
        location?.lat === placeSelection?.lat &&
        location?.lng === placeSelection?.lng);

    setPlaceSelection(location);

    // we want to executate the callback if location is changing
    //  from `false` to a real location
    //  from a real location to a real location (but NOT the SAME location)
    //  from a real location to `false`
    //  NOT from `false` to `false`
    if (!sameLocation) handleUpdatePlaceSelection(location);
  };

  return (
    <Fragment>
      <GoogleMapsAutocomplete
        aria-label={ariaLabel}
        aria-autocomplete="list"
        ariaControls="item-search-list"
        placeholder={label}
        onChange={handleAutocompleteSelection}
        value={placeSelection}
        type="text"
        listViewDisplayed={'auto'}
      />
      <StyledAutocompleteResults />
    </Fragment>
  );
};

GooglePlacesInput.propTypes = {
  ariaLabel: string,
  label: string,
  userCoordinates: object,
  handleUpdatePlaceSelection: func,
  onUnmount: func,
};

GooglePlacesInput.defaultProps = {
  ariaLabel: 'Type your search for a location here',
  label: 'Search for a location',
  userCoordinates: {},
  handleUpdatePlaceSelection: () => {},
  onUnmount: () => {},
};

export default GooglePlacesInput;
